export default {
    // shared across editCard components
    ec_save: "Guardar",
    ec_cancel: "Cancelar",
    ec_fail: "Error",
    ec_failed_save: "Error al guardar",
    ec_show: "Mostrar:",
    ec_rotate_img: "Rotar Imagen",
    ec_position_y: "PosiciónY :",
    ec_position_x: "PosiciónX :",
    ec_zoom: "Zoom :",
    ec_not_available_plan: "No disponible en tu plan actual",
    ec_premium_title: "Esta función está disponible para USUARIOS PREMIUM.",
    ec_premium_text: "Actualiza tu App a Premium con funciones avanzadas, por favor contacta a tu administrador en support@marketea.com o llámanos al 774-287-3353.",

    // editContact
    econt_find_me_at: "Encuéntrame en:",
    econt_contact_me: "Contáctame:",
    econt_title_form_ph: "Título del formulario",

    // editInfo
    ei_about_me: "Sobre mí:",
    ei_name: "Nombre",
    ei_last_name: "Apellido",
    ei_position: "Cargo:",
    ei_url: "Url:",
    ei_edit: "Editar",
    ei_wrong_url: "URL incorrecta o ya existe.",

    // editSchedule
    esched_hours: "Horario:",
    esched_open_prefix: "Abierto",
    esched_active: "Activo",
    esched_closed: "Cerrado",
    esched_open_at: "Abre a las",
    esched_close_at: "Cierra a las",

    // editMapIframe
    em_location: "Ubicación",
    em_insert_map: "Insertar Mapa",
    em_showcase: "Exhibición",
    em_insert_html: "Inserta el código HTML del mapa aquí",
    em_or_get_one: "o consigue uno",
    em_clear: "Limpiar",
    em_hide_map: "Ocultar Mapa",
    em_showcase_desc1: "Esta sección te permite crear una presentación visual de tu negocio.",
    em_showcase_desc2: "Puedes agregar de 1 a 4 imágenes junto con contenido descriptivo, que se mostrarán como un pequeño carrusel de imágenes.",
    em_tip: "Consejo:",
    em_tip_text: "Usa imágenes claras y de alta calidad que representen con precisión tu negocio.",
    em_add_image: "Agregar Imagen",
    em_enabled: "Habilitado",
    em_upload: "Subir",
    em_box_content: "Contenido del cuadro:",
    em_show_box: "Mostrar",
    em_slider_preview: "Vista previa del carrusel",
    em_org_placeholder: "Dirección o información de la organización",
    em_swal_title: "Eliminar la imagen y sus datos relacionados.",
    em_swal_text: "¿Estás seguro?",
    em_swal_confirm: "¡Sí, elimínala!",
    em_error_upload: "Error al subir la imagen, por favor inténtalo de nuevo.",

    // editPicProfile
    ep_profile_picture: "Foto de Perfil:",
    ep_hide_picture: "Ocultar Foto",

    // editBtns_action
    eb_buttons_action: "Acciones de Botones:",
    eb_background: "Fondo:",
    eb_ok: "Ok",
    eb_text_color: "Texto:",
    eb_save_color: "Guardar",
    eb_not_available_tpl: "No disponible para esta plantilla",
    eb_label: "Etiqueta:",
    eb_type: "Tipo:",
    eb_value: "Valor:",
    eb_system_action: "Acción del Sistema: Agregar Contacto",
    eb_custom_action: "Enlace de Acción Personalizado",

    // editColorTheme
    ect_color_theme: "Tema de Color:",
    ect_bg_type: "Tipo de Fondo",
    ect_color: "Color",
    ect_gradient: "Degradado",
    ect_image: "Imagen",
    ect_inactive: "(Inactivo)",
    ect_bg_desc: "Elige el tipo de fondo para tu plantilla. Puedes usar un color único, un degradado de 2 colores o una imagen.",
    ect_bg_color: "Color de Fondo (RGBA)",
    ect_gradient_1: "Color de Degradado 1 (RGBA)",
    ect_gradient_2: "Color de Degradado 2 (RGBA)",
    ect_bg_image: "Imagen de Fondo",
    ect_allowed_formats: "Formatos permitidos: .jpg, .jpeg, .png",
    ect_submit: "Confirmar",
    ect_invalid_file_title: "Archivo inválido",
    ect_invalid_file_text: "Solo se permiten archivos .jpg, .jpeg y .png.",
    ect_fail_load: "Error al cargar el tema de color",

    // editContactMe
    ecm_contact_us: "Contáctanos:",
    ecm_about_me: "Sobre Mí",
    ecm_phone_ph: "Tu número de teléfono, ej., 234567890",
    ecm_email_ph: "Tu correo electrónico, ej., example@example.com",
    ecm_address_ph: "Tu dirección, ej., Calle Principal 123",
    ecm_about_ph: "Escribe algo sobre ti...",

    // editCover
    ecov_cover_picture: "Foto de Portada:",
    ecov_image: "Imagen:",
    ecov_overlay: "Superposición:",
    ecov_bg_color: "Color de Fondo",
    ecov_image_bg: "Fondo de Imagen",
    ecov_video_bg: "Fondo de Video",
    ecov_video: "Video:",
    ecov_audio: "Audio:",
    ecov_upload_image: "Subir Imagen",
    ecov_upload_video: "Subir Video",
    ecov_video_too_large: "El video pesa más de 50 mb",
    ecov_create_video: "Crear video:",
    ecov_choose_images: "Elige tus imágenes",
    ecov_create_video_desc: "Crea tu propio video con tus imágenes preferidas.",
    ecov_create_video_limit: "( MÁX 5, MÍN 2 IMG)",
    ecov_setting_bg_video: "Configurando fondo con video",
    ecov_could_not_create: "No se pudo crear el video, inténtalo más tarde.",
    ecov_error_uploading: "Error al subir el archivo.",

    // editFontFamily
    eff_font_family: "Familia de Fuente:",
    eff_preview: "Vista previa",
    eff_select_font: "Seleccionar Fuente:",
    eff_default: "Predeterminada",
    eff_custom_fonts: "Fuentes Personalizadas",
    eff_google_fonts: "Fuentes de Google",
    eff_fail_save_font: "Error al guardar la fuente",

    // editTemplate
    etpl_choose_template: "Elegir Plantilla",
    etpl_classic_grid: "Grid Clásico",
    etpl_nightly: "Nightly",
    etpl_jaglow: "Jaglow",
    etpl_postorg: "Postorg",
    etpl_bmenu: "bMenu",
    etpl_bstore: "bStore",
    etpl_events: "Eventos",
    etpl_about_me: "Sobre mí",
}
